import React from 'react'

const Close = props => (
	<svg viewBox="0 0 50 50" {...props}>
		<path
			fill="#fff"
			d="M38.774 40.987l-29.91-29.91 2.262-2.263 29.91 29.91z"
		/>
		<path
			fill="#fff"
			d="M41.037 11.076l-29.91 29.91-2.263-2.262 29.91-29.91z"
		/>
	</svg>
)

export default Close



// WEBPACK FOOTER //
// ./src/components/Layout/nav/MobileNav/Overlay/IconClose.js